import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BranchesService } from '../branches.service';
import { Branch } from '../branch.model';
import { Page } from '../../../models/page-wrapper.model';

@Component({
  selector: 'app-list-branch',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  templateUrl: './list-branch.component.html',
  styleUrl: './list-branch.component.css',
  providers: [ConfirmationService, MessageService],
})
export class ListBranchComponent implements OnInit {
  branches: Branch[] = [];
  totalRecords = 0;
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private branchesService: BranchesService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.loadBranches();
    // Initial load is handled by the p-table's onLazyLoad event
  }

  loadBranches(event?: TableLazyLoadEvent) {
    this.isLoading = true;

    const size = event?.rows ?? 10;
    const page = event?.first ? Math.floor(event.first / size) : 0;

    const params: any = {
      page,
      size,
    };
    this.branchesService.getAllBranches(params).subscribe({
      next: (page: Page<Branch>) => {
        this.branches = page.content || [];
        this.totalRecords = page.totalElements;
        this.isLoading = false;
        console.log(this.branches);
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load branches.',
        });
        console.error(err);
        this.isLoading = false;
      },
    });
  }

  createBranch(): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['branches', 'create'] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }

  editBranch(id: number): void {
    this.router.navigate([
      '/ai-studio/session/current',
      { outlets: { canvasOutlet: ['branches', 'edit', id] } },
    ]);
  }

  deleteBranch(branch : Branch): void {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this branch?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',

      acceptLabel: 'Yes, Delete',
      rejectLabel: 'Cancel',

      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        this.branchesService.deleteBranch(branch.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `Branch Deleted successfully.`,
            });
            setTimeout(() => {
              this.loadBranches();
            }, 500);
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Failed to Delete branch.`,
            });
            console.error(err);
          },
        });
      },
    });
  }
}
